import React, { forwardRef, useEffect, useRef, Ref, RefObject } from 'react';
import styled from 'styled-components';

const StyledCheckbox = styled.input`
  height: 16px;
  width: 16px;
`;

interface IndeterminateCheckboxProps {
  indeterminate: boolean;
}

const IndeterminateCheckbox = forwardRef(
  (
    { indeterminate, ...rest }: IndeterminateCheckboxProps,
    ref: Ref<HTMLInputElement> | RefObject<HTMLInputElement>
  ) => {
    const defaultRef = useRef<HTMLInputElement>(null);
    const resolvedRef = ref ?? defaultRef;

    useEffect(() => {
      if (resolvedRef && 'current' in resolvedRef && resolvedRef.current) {
        resolvedRef.current.indeterminate = indeterminate;
      }
    }, [resolvedRef, indeterminate]);

    return <StyledCheckbox type="checkbox" ref={resolvedRef} {...rest} />;
  }
);

export default IndeterminateCheckbox;
